module.exports = __webpack_public_path__ + "static/media/clariti1d.588cbedb.jpg";